import { useSelector } from 'react-redux';

import { selectIsOfferWithMultiAds } from '../../selectors';
import { IState } from '../../store';

export function useIsMultiAdsSelector(): boolean {
  return useSelector<IState, boolean>(selectIsOfferWithMultiAds);
}
